import { Injectable } from '@angular/core';
import { TokenService } from '../token/token.service';
import { EnvironmentConfigService } from '../environment-config-service/environment-config.service';
import { SecureStorageService } from '../storage/secure-storage.service';
import { SecureStorageKey } from '../storage/models/secure-storage-key.enum';
import { AuthService } from '../auth-service/auth.service';
import { HealthScoreAiContextService } from '../health-score-ai-context-service/health-score-ai-context.service';
import { ProfileDataRefreshService } from '../profile-data-refresh-service/profile-data-refresh.service';
import { QuestionnaireService } from '../questionnaire-service/questionnaire.service';

@Injectable({
  providedIn: 'root',
})
export class ServicesStartupService {


  constructor(
    private _EnvironmentConfigService: EnvironmentConfigService,
    private _authService: AuthService,
    private _tokenService: TokenService,
    _profileDataRefreshService: ProfileDataRefreshService,
    _healthScoreAiContextService: HealthScoreAiContextService,
    _questionnaireService: QuestionnaireService,
  ) {}

  private async bootStrap(): Promise<void> {
    await this._authService.init();
    await this._EnvironmentConfigService.init();

    const redirectRoute = this.getParameterByName('route');
    if (redirectRoute) {
      const r = {
        route: redirectRoute
      };
      const jsonRoute = JSON.stringify(r);
      await SecureStorageService.set(SecureStorageKey.RedirectRoute, jsonRoute);

    }
  }

  public GetTokenService(): TokenService {
    return this._tokenService;
  }

  public async initServices(): Promise<void> {


    await this.bootStrap();

    // Load environment in background so welcome/intro can render without blocking on network.
    void this._EnvironmentConfigService.EnsureNetworkConfiguration('Services startup');
  }

  public async resumeApp(): Promise<boolean> {
    await this._authService.init();
    return true;
  }

  getParameterByName(name: string, url = window.location.href): string | null {
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
}
